import script from "./report2Gxmd.vue?vue&type=script&setup=true&lang=js"
export * from "./report2Gxmd.vue?vue&type=script&setup=true&lang=js"

import "./report2Gxmd.vue?vue&type=style&index=0&id=3a0cec19&lang=less"

const __exports__ = script;

export default __exports__